import type { NextFont } from 'next/dist/compiled/@next/font';
import { useEffect, useState } from 'react';

import { ResumeFontName, DeprecatedResumeFontName } from '@glass/web/modules/fonts/fontNames';
import resumeFonts from '@glass/web/modules/fonts/resumeFonts';

type LoadedFonts = Partial<Record<ResumeFontName | DeprecatedResumeFontName, NextFont>> | null;

const useResumeFontLoader = (fontName?: ResumeFontName | DeprecatedResumeFontName) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // todo: this should be context state so other usages can use as well
  const [fonts, setFonts] = useState<LoadedFonts>(null);

  useEffect(() => {
    if (fontName && typeof resumeFonts[fontName]?.loader !== 'function') {
      if (process.env.NODE_ENV === 'development') {
        console.warn('skipping font', fontName);
      }
      return;
    }
    // no font name or already loaded
    if (!fontName || fonts?.[fontName]) {
      return;
    }

    setLoading(true);
    resumeFonts[fontName]
      .loader()
      .then((loadedFont) => {
        setLoading(false);
        setFonts((prevFonts) => ({
          ...prevFonts,
          [fontName]: loadedFont,
        }));
      })
      .catch((err) => {
        // todo: track exception
        setLoading(false);
        setError(err);
      });
  }, [fontName, fonts]);

  return { loading, font: (fontName && fonts?.[fontName]) || null, error };
};

export default useResumeFontLoader;
